module.exports = __webpack_public_path__ + "img/cross.abda53c7.svg";